<div class="hymn-list">
  <button mat-icon-button mat-dialog-close (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
@for (hymn of hymns; track hymn.hymnNumber) {
  <mat-card class="mat-card-list" style="margin: 7px; height: 100px; overflow-y: hidden;" (click)="onHymnSelected(hymn.hymnNumber)">
    <mat-card-header>
      <div class="card-padded-top" style="font-size: x-large;" mat-card-avatar>{{ hymn.hymnNumber | number:'3.0' }}</div>
      <mat-card-title [class.card-padded-top]="hymn.english == null">{{ hymn.title }}</mat-card-title>
      <mat-card-subtitle *ngIf="hymn.english">{{ hymn.english }}</mat-card-subtitle>
    </mat-card-header>
  </mat-card>
} @empty {
  <li>There are no items.</li>
}
</div>
